import { SharedService } from '../shared/shared.service';
import { config } from '../config';
import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class ClinicService {
  constructor(public sharedService: SharedService) { }


  updateClinic(formData) {
    return this.sharedService.putData(config.editlinic, formData);
  }
  updateProfile(formData) {
    return this.sharedService.putData(config.getSetProfile, formData);
  }
  updateProfilePicture(imageName: string | null) {
    const stored = JSON.parse(localStorage.getItem('optplanner_user') || '{}');
    const companyId = stored.companyId || stored.company_id || '';
    const token = localStorage.getItem('optplanner_token') || stored.token || '';

    const headers = new HttpHeaders({
      'accept': '*/*',
      'x-company-id': companyId,
      'Authorization': token.startsWith('Bearer ') ? token : `Bearer ${token}`,
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    const value =
      imageName === null || imageName === undefined || imageName === ''
        ? 'null'
        : imageName;
    const body = new HttpParams().set('profile_pic', value).toString();
    return this.sharedService.httpclient.put(config.updateProfilePicture, body, { headers });
  }
  updatePassword(formData) {
    return this.sharedService.putData(config.changePassword, formData);
  }
  getProfile() {
    return this.sharedService.getData(config.getSetProfile);
  }
  addClinic(formData) {
      return this.sharedService.postData(config.addclinic, formData);
  }
  updateClinicHeader(){
    return this.sharedService.getData(config.getUpdatedClinicsList);
  }

  getClinic(data) {
    let url = `${config.getclinicTable}`;
    url = url.replace(":page", data.page).replace(":limit", data.limit);
    if(data.searchParam){
      url = `${url}&searchParam=${encodeURIComponent(data.searchParam)}`;
    }
    if(data.status !== null && data.status !== undefined){
      url = `${url}&status=${data.status}`;
    }
    return this.sharedService.getData(url);
  }

  // getClinicById(id) {
  //   const getClinicByIdUrl = `${config.getclinic}/${id}`;
  //   return this.sharedService.getData(getClinicByIdUrl);
  // }

  deleteClinic(id) {
    return this.sharedService.deleteData(`${config.deleteclinic}${id}`);
  }

  shownotification(){
    const url = `${config.usernotification}/user/all`
    return this.sharedService.getData(url);

  }
  shownotificationAll(payload){
    let url = `${config.usernotification}/user/all?limit=${payload.limit}&pageNo=${payload.pageNo}`;
    if(payload.searchParam){
      url =`${url}&searchParam=${payload.searchParam}`
    }else if(payload.startDate){
      url =`${url}&startDate=${payload.startDate}`
    }
    
    return this.sharedService.getData(url);

  }
  shownotificationOnInitAll(payload){
    let url = `${config.usernotification}/user/all?limit=${payload.limit}&pageNo=${payload.pageNo}&showAll=${payload.showAll}`;
    return this.sharedService.getData(url);

  }
  updateNotificationStatus(id){
    const url = `${config.usernotification}?id=`+id
    return this.sharedService.putIdData(url);

  }
  markAllNotificationStatusRead(){
    const url = `${config.usernotification}?markAsRead=`+true
    return this.sharedService.putIdData(url);

  }
  readAllNotificationAPI(ids){
    const url = `${config.usernotification}/`
    return this.sharedService.putData(url,ids);
  }
  DeleteNotification(id){
    const url = `${config.usernotification}/`+id;
    return this.sharedService.deleteData(url);
  }
  getAllTaxonomyCodes(){
    const url = `${config.getAllTaxonomyCodes}`;
    return this.sharedService.getData(url);
  }
}
